import React, { useState } from 'react';
import '../css/Section.css';

const whatsappUrl =
  'https://wa.me/94707246426?text=Hi%2C%20I%20would%20like%20to%20schedule%20a%20call%20about%20Aevolt%20Everflow.';

const whatsappPhone = '94707246426';

const everflowSpecs = [
  {
    name: 'Nano Cube',
    power: '150W',
    capacity: '216Wh',
    detail: 'Portable backup for phones, lights, laptops, and small essentials.',
  },
  {
    name: 'Nano',
    power: '250W',
    capacity: '360Wh / 624Wh',
    detail: 'Pure sine wave backup for basic home devices and small appliances.',
  },
  {
    name: 'Micro',
    power: '500W',
    capacity: '576Wh / 1.2kWh / 2.4kWh',
    detail: 'Mid-capacity home backup for everyday appliances.',
  },
  {
    name: 'Micro-H',
    power: '500W',
    capacity: '432Wh / 624Wh / 1.2kWh',
    detail: 'High-frequency inverter option for general home backup.',
  },
  {
    name: 'Mini',
    power: '800W',
    capacity: '1.2kWh',
    detail: 'Higher-capacity backup for more appliances and longer runtime.',
  },
  {
    name: 'Hybrid Systems',
    power: '1kW - 6kW',
    capacity: 'Aevolt batteries',
    detail: 'Hybrid solar systems with dust proof casing.',
  },
];

function createOrderMessage(spec) {
  return [
    `Hi, I would like to order Aevolt Everflow ${spec.name}.`,
    `Product details: ${spec.power}, ${spec.capacity}.`,
    spec.detail,
  ].join(' ');
}

function CTASection() {
  const [isProductPopupOpen, setIsProductPopupOpen] = useState(false);

  const openProductPopup = () => {
    setIsProductPopupOpen(true);
  };

  const openWhatsappOrder = (spec) => {
    const message = encodeURIComponent(createOrderMessage(spec));
    window.open(`https://wa.me/${whatsappPhone}?text=${message}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="order" className="cta-section">
      <div className="cta-box">
        <div className="cta-product" aria-label="Aevolt Everflow product" />
        <h2>Power Essentials</h2>
        <p>
          Order now or schedule a call with an energy advisor to learn more
          about Aevolt Everflow for your home.
        </p>

        <div className="hero-buttons">
          <button
            type="button"
            className="primary-btn"
            onClick={openProductPopup}
          >
            Order Aevolt Everflow
          </button>
          <a
            href={whatsappUrl}
            className="secondary-btn dark-outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Schedule a Call
          </a>
        </div>
      </div>

      {isProductPopupOpen && (
        <div
          className="product-popup"
          role="dialog"
          aria-modal="true"
          aria-labelledby="product-popup-title"
        >
          <div
            className="product-popup-backdrop"
            onClick={() => setIsProductPopupOpen(false)}
          />
          <div className="product-popup-panel">
            <button
              type="button"
              className="product-popup-close"
              aria-label="Close product details"
              onClick={() => setIsProductPopupOpen(false)}
            >
              x
            </button>
            <h3 id="product-popup-title"> Click to Order Aevolt Everflow </h3>
            <ul className="product-popup-list">
              {everflowSpecs.map((spec) => (
                <li key={spec.name}>
                  <button
                    type="button"
                    className="product-popup-item"
                    onClick={() => openWhatsappOrder(spec)}
                  >
                    <strong>Aevolt Everflow {spec.name}</strong>
                    <span>{spec.power} | {spec.capacity}</span>
                  </button>
                  <p className="product-popup-description">{spec.detail}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </section>
  );
}

export default CTASection;
